import { createAsyncThunk } from "@reduxjs/toolkit";
import { getSingleSportTicketListAPI } from "../../apiConfig/apiCall";

export const getSportTicketDetail = createAsyncThunk('getSportTicketDetail', async (ID) => {
    const response = await getSingleSportTicketListAPI(ID);
    return response.data;
});